import { isDocumentTypeCreditNote } from '@features/invoices/utils/isDocumentTypeCreditNote'

import { useInvoice } from '../../../contexts/invoiceContext'
import { getExternalInvoiceOriginatorReference } from '../utils/getExternalInvoiceOriginatorReference'
import { useInvoiceTransactions } from './useInvoiceTransactions'

export const useExternalInvoiceTransactions = () => {
  const { invoice } = useInvoice()
  const { externalInvoiceId, externalCreditNoteId } = invoice || {}

  const isCreditNote = isDocumentTypeCreditNote(invoice?.documentType)
  const externalId = isCreditNote ? externalCreditNoteId : externalInvoiceId

  const { transactions, isLoading } = useInvoiceTransactions(getExternalInvoiceOriginatorReference(externalId))

  return {
    transactions,
    isLoading,
  }
}
